import React, { useEffect } from "react";
import { Col, Row, Form } from "antd";
import GeneralCard from "./BasicsCards/GeneralCard";
import ContactCard from "./BasicsCards/ContactCard";
import AdditionalInformation from "./BasicsCards/AdditionalInformation";
import DimensionSettings from "./BasicsCards/DimensionSettings";

// import { getOneBasicsAction } from "../../../../store/action/admin/basicsActions";

const Basics = ({ userId, form }) => {
 
  return (
    <Form form={form} layout="vertical">
      <Row
        gutter={[16, 16]}
        style={{
          marginTop: 16,
        }}>
        <Col span={12}>
          <GeneralCard />
        </Col>
        <Col span={12}>
          <ContactCard />
        </Col>
      </Row>

      <Row
        gutter={[16, 16]}
        style={{
          marginTop: 16,
        }}>
        <Col span={12}>
          <AdditionalInformation />
        </Col>
        <Col span={12}>
          <DimensionSettings form={form} />
        </Col>
      </Row>
    </Form>
  );
};

export default Basics;
